import { render, staticRenderFns } from "./SelectDays.vue?vue&type=template&id=5af8ddb1"
import script from "./SelectDays.vue?vue&type=script&lang=js"
export * from "./SelectDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports